import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';


@Injectable()
export class UrlPathInterceptor implements HttpInterceptor {

  private _basePath: string = environment.apiRoot;

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = request.url;
    if (!url.startsWith('https://')) {
      url = this._basePath + (url.startsWith('/') ? url : ('/' + url));
      request = request.clone({
        url: url
      });
    }
    return next.handle(request);
  }
}
